import aa, { InsightsMethodMap } from 'search-insights';
import { chunk } from 'lodash-es';
import { algoliaSearch } from '@module/Algolia/resources/js/search/AlgoliaSearch';
import { InsightsTypes } from '@module/Algolia/resources/js/insights/types';

aa('init', {
  appId: window.Phoenix.config.ALGOLIA.appId,
  apiKey: window.Phoenix.config.ALGOLIA.apiKey,
});

export default {
  handleViews: async (ids: string[], index: string, eventName: string) => {
    if (ids.length === 0) {
      return;
    }

    const sendViews = async (items) => {
      try {
        await aa('viewedObjectIDs', {
          objectIDs: items,
          index: algoliaSearch.getFullIndexName(index),
          eventName,
        });
      } catch (e) {
        console.warn('Error when sending data to Algolia analytics', e);
      }
    };

    if (ids.length <= 20) {
      await sendViews(ids);
    }

    await Promise.all(chunk(ids, 20).map(sendViews));
  },

  handleClick: async (data: any, type: InsightsTypes = 'click') => {
    if (!data.objectIDs || !data.index) {
      return;
    }

    data.index = algoliaSearch.getFullIndexName(data.index);

    let method: keyof InsightsMethodMap;

    switch (type) {
      case 'addToCart':
        method = data.queryID ? 'addedToCartObjectIDsAfterSearch' : 'addedToCartObjectIDs';
        break;
      case 'conversion':
        method = data.queryID ? 'convertedObjectIDsAfterSearch' : 'convertedObjectIDs';
        break;
      default:
        method = data.queryID ? 'clickedObjectIDsAfterSearch' : 'clickedObjectIDs';
    }

    try {
      await aa(method, data);
    } catch (e) {
      console.warn('Error when sending data to Algolia analytics', e);
    }
  },
};
